/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for ExternalUserLinkAccount.
 *
 */

import { ReduxUtils } from '@spm/core';

const POST_SD_EXTERNALUSER_LINK_ACCOUNT = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `EXTERNALUSERLINKACCOUNT/POST_SD_EXTERNALUSER_LINK_ACCOUNT`
);

export { POST_SD_EXTERNALUSER_LINK_ACCOUNT };
